import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface AdressePictoProps extends pictoProps {
}

export interface AdressePictoState extends pictoState {
}

export class AdressePicto extends Picto<AdressePictoProps,AdressePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.adressePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(AdressePicto);
